import i18n from "config/i18next";

i18n.addResources("es", "workzones", {
  enterNumber: "Ingresá el n°",
  workzone: "Zona de trabajo",
  actualAmount: "Cantidad actual",
  newAmount: "Nueva cantidad",
  indication: "Ingresá la nueva cantidad de transacciones por zona de trabajo",
  transactions: "Transacciones",
  date: "Fecha",
  region: "Región",
});
